import { render, staticRenderFns } from "./LabelGenIndex.vue?vue&type=template&id=a928ac5a"
import script from "./LabelGenIndex.vue?vue&type=script&lang=js"
export * from "./LabelGenIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a928ac5a')) {
      api.createRecord('a928ac5a', component.options)
    } else {
      api.reload('a928ac5a', component.options)
    }
    module.hot.accept("./LabelGenIndex.vue?vue&type=template&id=a928ac5a", function () {
      api.rerender('a928ac5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/labelGen/LabelGenIndex.vue"
export default component.exports